export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/arrow-black.50597062.svg","height":16,"width":26};